import { checkWordEquality } from './word-american-british-checker';

export const compareWord = async ({ word1, word2 }: { word1: string; word2: string }) => {
  if (!word1 || !word2) {
    return false;
  }

  const isExactlyEqual = word1.toLowerCase() === word2.toLowerCase();
  if (isExactlyEqual) {
    return true;
  }

  const isEqual = checkWordEquality(word1, word2);
  if (isEqual) {
    return true;
  }
  return false;
};
